import React, { useState, useContext } from "react";

import MainSearch from "./SearchFilter";
import MainFilter from "../common/MainFilter";

import db from "../../services/query";

import { YearContext } from "../../contexts/yearContext";

const Filter = ({ query, hasFilter, allStudents }) => {
  const [filter, showFilter] = useState(false);

  const [genderList, getGender] = useState([]);
  const [facultyList, getFaculty] = useState([]);
  const [departmentList, getDepartment] = useState([]);
  const [studentStatusList, getStudentStatus] = useState([]);
  const [entryYearList, getEntryYears] = useState([]);

  const { entryYear } = useContext(YearContext);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [years, faculties, genders, departments, statuses] = await Promise.all([
          db.getAll(`dropdowns/entryYears`),
          db.getAll(`dropdowns/faculties`),
          db.getAll(`dropdowns/genders`),
          db.getAll(`dropdowns/departments`),
          db.getAll(`dropdowns/studentStatus`),
        ]);
        if (cancelled) return;
        getEntryYears(years?.data?.data || []);
        getFaculty(faculties?.data?.data || []);
        getGender(genders?.data?.data || []);
        getDepartment(departments?.data?.data || []);
        getStudentStatus(statuses?.data?.data || []);
      } catch (_e) {
        /* ignore dropdown load errors */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const inputs = [
    {
      name: "student_name",
      label: "نام",
      type: "text",
      maxLength: 32,
    },
    {
      name: "student_father_name",
      label: "نام پدر",
      type: "text",
      maxLength: 32,
    },
    {
      name: "gender_id",
      label: "جنسیت",
      type: "select",
      data: genderList,
    },
    {
      name: "student_phone",
      label: "شماره تماس",
      type: "text",
      maxLength: 14,
    },
    {
      name: "faculty_id",
      label: "پوهنحی",
      type: "select",
      data: facultyList,
    },
    {
      name: "department_id",
      label: "دیپارتمنت",
      type: "select",
      data: departmentList,
    },
    {
      name: "entry_year_id",
      label: "سال ورودی",
      type: "select",
      data: entryYearList,
    },
    {
      name: "aria_id",
      label: "کد دانشجو",
      type: "text",
      maxLength: 20,
    },
  ];

  if (allStudents) {
    inputs.push(
        {
          /* TODO: change to a dropdown and get data from api*/
          name: "student_status_id",
          label: "حالت",
          type: "select",
          data: studentStatusList,
        })
  }else {
    inputs.push({
      name: "enrolled",
      label: "حالت",
      type: "select",
      data: [{id: "enrolled" , name: "شامل صنف شده اند"}, {id: "not-enrolled", name: "شامل صنف نشده اند"}],
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      student_name,
      student_father_name,
      gender_id,
      student_phone,
      faculty_id,
      department_id,
      entry_year_id,
      aria_id,
      enrolled,
      student_status_id,
    } = e.target;

    query({
      keyword: student_name.value,
      student_father_name: student_father_name.value,
      student_phone: student_phone.value,
      gender_id: gender_id.value,
      faculty_id: faculty_id.value,
      department_id: department_id.value,
      entry_year_id: allStudents ? entry_year_id.value : (entry_year_id.value || entryYear),
      aria_id: aria_id.value,
      enrolled: enrolled?.value,
      student_status_id: student_status_id?.value,
    });
  };

  return (
    <React.Fragment>
      <MainSearch showFilter={showFilter} query={query} hasFilter={hasFilter} allStudents={allStudents} />
      {filter && (
        <MainFilter
          handleSubmit={handleSubmit}
          showFilter={showFilter}
          filter={filter}
          inputs={inputs}
          query={query}
        />
      )}
    </React.Fragment>
  );
};

export default Filter;
